import React from "react"
import { StyledDrawer } from "./style"

const Drawer = (props: any) => {
  return <StyledDrawer {...props} />
}

export default Drawer
